import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { AuthProvider } from './components/AuthContext';
import { ThemeProvider } from './components/ThemeProvider';
import { CurrencyProvider } from './contexts/CurrencyContext';
import './i18n';

// Preload critical images
const preloadImages = [
  'https://imgur.com/3zSo08L.jpg',
  'https://imgur.com/OJoUqFM.jpg',
  'https://imgur.com/4IviNqy.jpg',
  'https://imgur.com/vfIz6yT.jpg'
];

preloadImages.forEach(src => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = src;
  document.head.appendChild(link);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <CurrencyProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </CurrencyProvider>
    </ThemeProvider>
  </StrictMode>
);